/**
 * the single source of truth for calculator metadata
 */

export const CALCULATOR_CONFIGS = [
  {
    id: "ccbwcalc",
    title: "Creatinine clearance calculator for adults",
    path: "/calculator/ccbwcalc",
    component: "CrcCalcApp",
  },
  {
    id: "gfrcalc", 
    title: "Glomerular filtration rate (GFR) calculator for children",
    path: "/calculator/gfrcalc",
    component: "GfrCalcApp",
  },
  {
    id: "bsacalc",
    title: "Body surface area calculator", 
    path: "/calculator/bsacalc",
    component: "BsaCalcApp",
  },
  {
    id: "ibwcalc",
    title: "Ideal body weight calculator",
    path: "/calculator/ibwcalc", 
    component: "IbwCalcApp",
  },
  {
    id: "lbwcalc",
    title: "Lean body weight calculator",
    path: "/calculator/lbwcalc",
    component: "LbwCalcApp", 
  },
  {
    id: "idcalc",
    title: "Aminoglycoside initial dose calculator for adults",
    path: "/calculator/idcalc",
    component: "AbxCalcApp",
  },
  // Special cases for aminoglycosides
  {
    id: "Amikacin",
    title: "Amikacin initial dose calculator for adults", 
    path: "/calculator/Amikacin",
    component: "AbxCalcApp",
  },
  {
    id: "Gentamicin", 
    title: "Gentamicin initial dose calculator for adults",
    path: "/calculator/Gentamicin",
    component: "AbxCalcApp",
  },
  {
    id: "Tobramycin",
    title: "Tobramycin initial dose calculator for adults", 
    path: "/calculator/Tobramycin",
    component: "AbxCalcApp",
  },
];

export const getCalculatorById = (id) => {
  return CALCULATOR_CONFIGS.find(calc => calc.id === id);
};

export const getCalculatorTitle = (id) => {
  const calc = getCalculatorById(id);
  return calc ? calc.title : "Calculator";
};

/**
 * Get menu items for sidebar/navigation
 * Excludes special aminoglycoside variants to avoid duplication
 */
export const getCalculatorMenuItems = () => {
  return CALCULATOR_CONFIGS.filter(calc => 
    !["Amikacin", "Gentamicin", "Tobramycin"].includes(calc.id)
  );
};

export const getAllCalculatorIds = () => {
  return CALCULATOR_CONFIGS.map(calc => calc.id);
};

export const isValidCalculatorId = (id) => {
  return CALCULATOR_CONFIGS.some(calc => calc.id === id);
};
